class DataLayer {
  buttons
  extraConfig = {}
  constructor() {
    window.dataLayer = window.dataLayer || []

    this.extraConfig = JSON.parse(document.documentElement.dataset.trackingPage)

    this.buttons = document.querySelectorAll('[data-tracking]')
    Array.from(this.buttons).map((button) =>
      button.addEventListener('click', (e) => {
        const event = e.currentTarget.dataset.trackingEvent
        const label = e.currentTarget.dataset.trackingLabel
        const config = {}

        if (event === 'video') {
          config.event = 'video_watched'
          config.video_title = label
          config.video_type = e.currentTarget.dataset.trackingType
        }

        if (event === 'file') {
          config.event = 'file_download'
          config.file_title = label
          config.file_type = e.currentTarget.dataset.trackingType
        }

        this.pushEvent(event, config)
      })
    )

    window.jQuery(document).on('gform_confirmation_loaded', (e) => {
      this.pushEvent('form_submit', {
        screen_url: window.location.href + 'form_submit',
      })
    })
  }

  pushEvent(event, config) {
    dataLayer.push({
      event: event || '',
      page: window.location.href,
      ...config,
      ...this.extraConfig,
    })
  }
}

!(async function () {
  if ('complete' === document.readyState) {
    window.DataLayer = DataLayer
    window.tracking = new DataLayer()
  } else {
    window.addEventListener('load', () => {
      window.DataLayer = DataLayer
      window.tracking = new DataLayer()
    })
  }
})()
